
import store from '@/store/index';
export default {
  namespaced: true,
  state: {
  },
  actions: {
    /**
     * @class pool
     * @param {Object} state vuex state
     * @param {Array} routes routes
     */
     init ({ commit, dispatch }) {

    },
    /**
     * 个人设置
     * @param commit
     * @param dispatch
     */
    userInit({commit,dispatch}) {
    }


  }
}



// WEBPACK FOOTER //
// ./src/store/home/modules/page.js